<div class="value-stakes user-section my-2" *ngIf="stArr">
  <h3 class="us_title">Stakes</h3>
  <!-- <div class="input-group mb-2">
    <input type="number" class="form-control" placeholder="Enter stakes...">
    <div class="input-group-prepend">
      <span class="input-group-text">add</span>
    </div>
  </div> -->

  <div class="btn-group">
    
    <button class="btn-stakes" *ngFor="let arr of stArr;let i=index;">
        <input type="number" name="stackVal{{i}}" [(ngModel)]="stacks['stake_amount_'+ (i+1)]" (change)="stacks['stake_name_'+ (i+1)] = stacks['stake_amount_'+ (i+1)]+'';" />
    </button>
    <button type="button" class="btn btn-dark btn-block" (click)="setBtnVal()">Submit</button>
    
    <!-- <button type="button" class="btn-stakes">1000 <i class="icofont-close"></i></button>
      <button type="button" class="btn-stakes">10,000 <i class="icofont-close"></i></button>
      <button type="button" class="btn-stakes">50,000 <i class="icofont-close"></i></button>
      <button type="button" class="btn-stakes">1,00,000 <i class="icofont-close"></i></button>
      <button type="button" class="btn-stakes">5,00,000 <i class="icofont-close"></i></button> -->
    </div>
</div>
<app-loader class="full-overlay" *ngIf="isLoad"></app-loader>